import { z } from 'zod';

const BaseTreeNodeSchema = z.object({
  key: z.string(),
  label: z.string().optional(),
  data: z.any().optional(),
  icon: z.string().optional(),
  expandedIcon: z.any().optional(),
  collapsedIcon: z.any().optional(),
  leaf: z.boolean().optional(),
  expanded: z.boolean().optional(),
  type: z.string().optional(),
  partialSelected: z.boolean().optional(),
  style: z.string().optional(),
  styleClass: z.string().optional(),
  draggable: z.boolean().optional(),
  droppable: z.boolean().optional(),
  selectable: z.boolean().optional(),
  lazy: z.boolean().optional(),
});

export type TreeNode = z.infer<typeof BaseTreeNodeSchema> & {
  children?: TreeNode[];
}

export const TreeNodeSchema: z.ZodType<TreeNode> = BaseTreeNodeSchema.extend({
  children: z.lazy(() => TreeNodeSchema.array().optional()),
});

export const TreeElementSchema = z.object({
  id: z.string().uuid(),
  parentId: z.string().uuid().nullable(),
  children: z.set(z.string().uuid()),
  treeNode: TreeNodeSchema,
});

export type TreeElement = z.infer<typeof TreeElementSchema>;
